import { z } from "zod";

import { supportedExpressionOutputTypeSchema } from "./enums";

export const printVariableInfoSchema = z.object({
	id: z.string(),
	key: z.string(),
	value: z.string(),
});

export const printVariableExpressionSchema = z.object({
	id: z.string(),
	key: z.string(),
	expression: z.string(),
	outputType: supportedExpressionOutputTypeSchema,
});
